'use es6';

import Client from 'AdsUI/data/Client';
import calculateTimeRange from 'AdsUI/lib/CalculateTimeRange';
import { EntityTypes } from 'AdsUI/lib/Constants';
const baseUrl = 'ads/v1/reports';
export const fetchCampaignDetails = (network, accountId, campaignId, timeRange, attributionType) => {
  const url = `${baseUrl}/${network.toLowerCase()}/account/${accountId}/campaign/${campaignId}/details`;
  return Client.apiRequest(url, {
    type: 'GET',
    query: Object.assign({}, calculateTimeRange(timeRange), {
      attributionType
    })
  });
};
export const fetchChildrenByEntity = (network, accountId, campaignId, entityType, entityId, timeRange, attributionType, statuses) => {
  const rootUrl = `${baseUrl}/${network.toLowerCase()}/account/${accountId}/campaign/${campaignId}`;
  let url;

  switch (entityType) {
    case EntityTypes.ADGROUP:
      {
        url = `${rootUrl}`;
        break;
      }

    case EntityTypes.AD:
      {
        url = `${rootUrl}/adgroup/${entityId}`;
        break;
      }

    case EntityTypes.KEYWORD:
      {
        url = `${rootUrl}/adgroup/${entityId}/keywords`;
        break;
      }

    default:
      throw new Error(`Unknown entity type ${entityType}`);
  }

  return Client.apiRequest(url, {
    type: 'GET',
    query: Object.assign({}, calculateTimeRange(timeRange), {
      attributionType,
      status: statuses.toArray()
    })
  });
};
export const fetchCampaignBreakdowns = (accountId, campaignId, timeRange) => {
  const url = `${baseUrl}/facebook/account/${accountId}/campaign/${campaignId}/breakdown`;
  return Client.apiRequest(url, {
    type: 'GET',
    query: calculateTimeRange(timeRange)
  });
};
export const fetchAdSequence = (adSequenceId, timeRange, attributionView) => {
  return Client.apiRequest(`${baseUrl}/ad-sequence/${adSequenceId}/details`, {
    type: 'GET',
    query: Object.assign({}, timeRange && calculateTimeRange(timeRange), {}, attributionView && {
      attributionType: attributionView
    })
  });
};